import React from 'react';
import { Box, Chip, Container, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { PassportRequest, PassportRequestStatus } from '../../../types/PassportRequest';
import { DateTime } from 'luxon';
import { RunCircleRounded, MopedRounded, CheckCircleRounded, CancelRounded, FiberNewRounded } from '@mui/icons-material';

const getIconFromStatus = (status: PassportRequestStatus) => {
  if (status === 'Processing') return <RunCircleRounded />;
  else if (status === 'Available') return <MopedRounded />;
  else if (status === 'Completed') return <CheckCircleRounded />;
  else if (status === 'Cancelled') return <CancelRounded />;
  return <FiberNewRounded />;
};

const getColorFromStatus = (status: PassportRequestStatus) => {
  if (status === 'Processing') return 'warning';
  else if (status === 'Available') return 'secondary';
  else if (status === 'Completed') return 'success';
  else if (status === 'Cancelled') return 'error';
  return 'info';
};

type Props = {
  passportRequest: PassportRequest
}

export const PassportRequestInfoBox = (props: Props) => {
  const { passportRequest } = props;

  return (
    <Container disableGutters>
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell width={250}>Id Number</TableCell>
                <TableCell>{passportRequest.idNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Name</TableCell>
                <TableCell>{passportRequest.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Type</TableCell>
                <TableCell>{passportRequest.type}</TableCell>
              </TableRow>
              {passportRequest.type === 'Copy' && (
                <TableRow>
                  <TableCell width={250}>Reason</TableCell>
                  <TableCell>{passportRequest.reason}</TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell width={250}>Date Requested</TableCell>
                <TableCell>{DateTime.fromISO(passportRequest.dateRequested).toFormat('MMMM dd, yyyy — hh:mm:ss a')}</TableCell>
              </TableRow>
              <TableRow sx={{
                '&:last-child td, &:last-child th': { border: 0 } 
              }}>
                <TableCell width={250}>Status</TableCell>
                <TableCell>
                  <Chip 
                    icon={getIconFromStatus(passportRequest.status)} 
                    label={passportRequest.status} 
                    color={getColorFromStatus(passportRequest.status)}
                    variant="outlined" />
                  </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  )
};
